import { Injectable } from '@angular/core';
import { SOURCE_TYPE } from '../constants/Tpiq.constants';
import {Observable, of, throwError} from 'rxjs';
import {Session} from '../services/Session';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import { RapCommitPayload, RapPlanData } from '../models/rap-session.model';

export function getTPCustomerListUrl(org, user, protectedView) {
  let url = `/TaxPlanningServices/orgs/${org}/users/${user}/clientstrategy/list`;
  if (protectedView) {
    url += `?protectedView=true`;
  } else {
    url += `?protectedView=false`;
  }
  return url;
}

export function getTaxPlanningClients(org, user, protectedView, clientStatus, listType) {
  let url = `/TaxPlanningServices/org/${org}/users/${user}/clients/list`;
  if (protectedView) {
    url += (clientStatus) ? `?protectedView=true&status=${clientStatus}` : `?protectedView=true`;
    url += (listType) ? `&type=${listType}` : ``;
  } else if (clientStatus) {
    url += (listType) ? `?protectedView=false&status=${clientStatus}&type=${listType}` : `?protectedView=false&status=${clientStatus}`;
  } else if (listType) {
    url += `?protectedView=false&type=${listType}`;
  }

  return url;
}

export function getExternalUsersUrl(org, user) {
  return `/TaxPlanningServices/org/${org}/users/${user}/clients/owners`;
}

export function createTaxPlanningClientUrl(org, user) {
  return `/TaxPlanningServices/org/${org}/users/${user}/clients`;
}

export function taxPlanningClientUrl(org, user, clientId, protectedView?) {
  let url = `/TaxPlanningServices/org/${org}/users/${user}/clients/${clientId}`;
  if (protectedView) {
    url += `?protectedView=true`;
  }
  return url;
}

export function createCustomRateUrl(org, user, planId) {
  return `/TaxPlanningServices/org/${org}/users/${user}/customrates/plan/${planId}`;
}

export function deleteCustomRateUrl(org, user, customRateId) {
  return `/TaxPlanningServices/org/${org}/users/${user}/customrates/${customRateId}`;
}

export function createTaxPlanForClient(org, userId){
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/clientstrategy`;
}

export function disclaimerUrl(org, userId){
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/disclaimer`;
}

export function taxPlanningHomepageContentUrl(userId, orgId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/homepage`;
}

export function getTaxPlanForClient(org, userId, taxPlanId, year?, sortKey?, sortOrder?, protectedView?){
  let url = `/TaxPlanningServices/orgs/${org}/users/${userId}/clientstrategy/${taxPlanId}`;
  if (year){
    url += `?filter=${year}`;
    if (sortKey){
      url += `&sortKey=${sortKey}&sortOrder=${sortOrder}`;
    }
  }
  if (sortKey){
    url += `?sortKey=${sortKey}&sortOrder=${sortOrder}`;
  }
  if (protectedView) {
    if (year || sortKey) {
      url += `&protectedView=true`;
    } else {
      url += `?protectedView=true`;
    }
  }
  return url;
}

export function getTaxPlanDeleteForClient(org, userId, taxPlanId, deleteAll?){
  let url = `/TaxPlanningServices/orgs/${org}/users/${userId}/clientstrategy/${taxPlanId}`;
  if (deleteAll){
    url += `?deleteAll=true`;
  }
  return url;
}

export function getClients(org, userId){
  return `/TaxPlanningServices/user/${userId}/companies2/compactList/clients?domain=wall&org=${org}`;
}

export function costLinesUrl(org, userId, taxPlanId){
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/clientstrategy/${taxPlanId}/costline`;
}

export function cashflowLinesUrl(org, userId, taxPlanId){
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/plans/${taxPlanId}/third-party-transactions`;
}

export function addUpdateStrategyLine(orgId, userId, taxPlanId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${taxPlanId}/strategy`;
}

export function deleteStrategyLine(orgId, userId, taxPlanId, strategyId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${taxPlanId}/strategy/${strategyId}`;
}

export function saveChecklistUrl(orgId, userId, taxStrategyId){
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/strategy/${taxStrategyId}/checklist`;
}

export function strategyLineChecklist(orgId, userId, clientStrategyId, strategyLineId){
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clientStrategy/${clientStrategyId}/strategy/${strategyLineId}/checklist`;
}

export function clientPlanList(orgId, userId, clientId, planYear, status, isCustomer){
  let url =  `/TaxPlanningServices/orgs/${orgId}/users/${userId}/client/${clientId}/strategies?year=${planYear}`;
  if (status){
    url += `&status=${status}`;
    if (isCustomer) {
      url += `&isCustomer=${isCustomer}`;
    }
  } else if (isCustomer) {
    url += `&isCustomer=${isCustomer}`;
  }
  return url;
}

export function clientEntities(orgId, userId, clientId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/client/${clientId}/entities`;
}

export function clientEntity(orgId, userId, clientId, entityId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/client/${clientId}/entities/${entityId}`;
}

export function duplicatePlan(orgId, userId, taxPlanId, planYear){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/plan/${taxPlanId}?year=${planYear}`;
}

export function renamePlan(orgId, userId, taxPlanId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/plan/${taxPlanId}`;
}

export function getExternalUsers(orgId, userId){
  return `/TaxPlanningServices/users/${userId}/orgs/${orgId}/clients/owners`;
}

export function taxPlanningSummary(orgId, userId, clientStrategyId, view?, filter?, noOfYears?, isMerged?){
  let url = `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${clientStrategyId}/summary`;
  if (view){
    url += `?groupby=${view}`;
    if (filter){
      url += `&filter=${filter}`;
    } 
    if (isMerged) {
      url += `&isMerged=${isMerged}`;
    }
    if (noOfYears) {
      url += `&noOfYears=${noOfYears}`;
    }
  } else if (filter){
    url += `?filter=${filter}`;
    if (noOfYears) {
      url += `&noOfYears=${noOfYears}`;
    }
  } else if (noOfYears) {
    url += `?noOfYears=${noOfYears}`;
  }
  return url;
}

export function feedbackUrl(orgId, userId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/feedback`;
}

export function getTermsAndConditionsUrl(orgId, userId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/terms`;
}

export function acceptTermsUrl(orgId, userId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/terms/accept`;
}

export function getTaxPlanningFirmCreationUrl(orgId, userId){
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/firmReplication`;
}

export function getInvitationUrl(orgId, userId){
  return `/TaxPlanningServices/org/${orgId}/user/${userId}/taxPlanningEmail`;
}

export function planPublishUrl(orgId, userId, planId, type){
  if (type === 'publish') {
    return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/publish?status=publish`;
  } else {
    return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/publish?status=unpublish`;
  }
}

export function clientTaxPlanningStatusUrl(orgId, userId) {
  return `/TaxPlanningServices/taxplanning/orgs/${orgId}/users/${userId}`;
}

export function saveBillingInfoUrl(orgId, userId, promoCode, yearSubscribe, manageBilling) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/payments?code=${promoCode}&yearly=${yearSubscribe}&editBilling=${manageBilling}`;
}

export function getPublicKeyUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/payments/keys`;
}

export function getTaxPlanningInfoOfTaskUrl(orgId, userId, taskId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/tasks/${taskId}/client-todos`;
}

export function getGenerateTotalPublishedSavingsByStrategyUrl(orgId, userId, graphType, year) {
  let url = `/TaxPlanningServices/org/${orgId}/users/${userId}/tax-savings`;
  if (graphType) {
    url += `?view=${graphType}`;
  } else {
    url += `?view=`;
  }
  if (year) {
    url += `&year=${year}`;
  } else {
    url += `&year=`;
  }
  return url;
}

export function getGenerateTotalPublishedSavingsByClientUrl(orgId, userId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/top-saving-clients`;
}

export function getTotalPublishedTaxplansByMonthUrl(orgId, userId, year) {
  let url = `/TaxPlanningServices/org/${orgId}/users/${userId}/published-plans-by-month`;
  if (year) {
    url += `?year=${year}`;
  }
  return url;
}

export function getFirmsMostPopularPlansUrl(orgId, userId, year) {
  let url = `/TaxPlanningServices/org/${orgId}/users/${userId}/published-strategies`;
  if (year) {
    url += `?year=${year}`;
  }
  return url;
}

export function getTop5StrategiesUrl(orgId, userId, year) {
  let url = `/TaxPlanningServices/org/${orgId}/users/${userId}/top5-strategies`;
  if (year) {
    url += `?year=${year}`;
  }
  return url;
}

export function saveFirmAddressUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/address`;
}

export function promoCodeForBillingUrl(orgId, userId, code) {
  return `/TaxPlanningServices/org/${orgId}/user/${userId}/couponcodes/validate?code=${code}`;
}

export function getarchiveOrUnarchivePlanUrl(orgId, userId, taxPlanId, status, archiveOnly, planName) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${taxPlanId}/archive?status=${status}&archiveOnly=${archiveOnly}&planName=${planName}`;
}

export function getClientDefaultYearUrl(orgId, userId, clientId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${clientId}/defaultYear`;
}

export function getClientDefaultPlanInfoUrl(orgId, userId, clientId){
  return  `/TaxPlanningServices/orgs/${orgId}/users/${userId}/client/${clientId}/strategies/customer?status=publish`;
}

export function getExportROIExcelUrl(orgId, userId){
  return  `/TaxPlanningServices/orgs/${orgId}/users/${userId}/export?type=excel`;
}

export function getROIMinimizedSectionsUrl(orgId, userId, planId, sectionsString) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/minimize_roi_sections?sections=${sectionsString}`;
}

export function getStrategyROIGraphUrl(orgId, userId, planId, year) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/roi-graph?filter=${year}`;
}

export function getUpdateLogoUrl(orgId, userId, logoUrl) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/updatelogo?url=${logoUrl}`;
}

export function getCustomerDashboardPieChartDataUrl(orgId, userId, view, year) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/customer/tax-savings?view=${view}&year=${year}`;
}

export function getClientTasksInfoUrl(orgId, userId, year) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/tasks?year=${year}`;
}

export function getSubscriptionDataUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/payments/subscription`;
}

export function subscriptionStatusUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/payments/subscription-status`;
}

export function applyPromoCodeUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/payments/apply-promocode`;
}

export function getCustomerLoginToken(orgId, userId, userEmail) {
  return `/TaxPlanningServices/orgs/${orgId}/user/${userId}/clientLogin?clientEmailId=${userEmail}`;
}

export function getUserSingleSignOnUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/payments/single-signon`;
}

export function getSubscriptionDetailsUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/subscription/details`;
}

export function doNotRenewUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/subscription/do-not-renew`;
}

export function getClientPlansListUrl(orgId, userId, clientId, sortKey, sortOrder, searchText) {
  let url = `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/${clientId}/plans`
  if (sortKey){
    url += `?sortKey=${sortKey}&sortOrder=${sortOrder}`;
    if (searchText) {
      url += `&search=${searchText}`;
    }
  } else if (searchText){
    url += `?search=${searchText}`;
  }
  return url;
}

export function getMakeDefaultYearUrl(orgId, userId, year, graphName) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/default-year?year=${year}&graph=${graphName}`;
}

export function getDashboardDefaultYearDataUrl(orgId, userId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/default-years`;
}

export function getUpdateNavigateActionUrl(orgId, userId, actionName) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/click?hashtag=${actionName}`;
}

export function getUserHistoryReportDataUrl(orgId, userId, sortKey, sortOrder) {
  let url = `/TaxPlanningServices/orgs/${orgId}/users/${userId}/reports/user-login-history`;
  if (sortKey){
    url += `?sortKey=${sortKey}&sortOrder=${sortOrder}`;
  }
  return url;
}

export function getFeedbackReportDataUrl(orgId, userId, sortKey, sortOrder, firmId, type) {
  let url = `/TaxPlanningServices/orgs/${orgId}/users/${userId}/feedback`;
  if (sortKey){
    url += `?sortKey=${sortKey}&sortOrder=${sortOrder}`;
    if (type) {
      url += `&feedbackType=${type}&firmId=${firmId}`;
    }
  } else if (type) {
    url += `?feedbackType=${type}&firmId=${firmId}`;
  }
  return url;
}

export function getTaxPlanHomeStateUpdateUrl(orgId, userId, clientId, planId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/${clientId}/plans/${planId}`;
}

export function getDownloadRoiPresentationUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/export/ppt`;
}

export function getDownloadWordQuestionnaireUrl(orgId, userId, questionnaireId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/export/questionnaire/${questionnaireId}/word`;
}

export function getSaveCustomPresentationDataUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/ppt/customizations`;
}

export function getCustomPresentationDataUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/ppt/customizations/${planId}`;
}

export function getPlanTaxEstimatesUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/taxestimates/plans/${planId}`;
}

export function getTpiqClientInfoUrl(orgId, userId, emailId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/email/${emailId}`;
}

export function getsavePlanIntroductionLetterUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/intro-letter`;
}

export function getPlanStrategiesDataUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/strategy/custom-pdf`;
}

export function getPublishedPlansForTaxEstimatesUrl(orgId, userId, customerId) {
  return  `/TaxPlanningServices/org/${orgId}/users/${userId}/taxestimates?customer=${customerId}&status=publish`;
}

export function getPublishPlanTaxEstimatesUrl(orgId, userId, estimateId, publishType) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/taxestimates/${estimateId}/publish?status=${publishType}`;
}

export function getDashboardClickablePlansUrl(orgId, userId, strategyId, year, sortKey, sortOrder) {
  let url = `/TaxPlanningServices/org/${orgId}/users/${userId}/plans/${strategyId}?year=${year}`;
  if (sortKey){
    url += `&sortKey=${sortKey}&sortOrder=${sortOrder}`;
  }
  return url;
}

export function getDashboardClickablePlansByMonthUrl(orgId, userId, month, year, sortKey, sortOrder) {
  let url = `/TaxPlanningServices/org/${orgId}/users/${userId}/published-plans/month?year=${year}&month=${month}`;
  if (sortKey){
    url += `&sortKey=${sortKey}&sortOrder=${sortOrder}`;
  }
  return url;
}

export function getPlansForClientUrl(orgId, userId, clientId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/${clientId}/compactplans`;
}

export function getTaxPlanStrategiesInfoUrl(orgId, userId, planId, type) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/strategies?type=${type}`;
}

export function getCreateTaskForPlanStrategyUrl(orgId, userId, lineId, goalDate) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/tasks/plan-line/${lineId}?goalDate=${goalDate}`;
}

export function getActualProjectedGraphUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/actual-projected-graph`;
}

export function geExportDocUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/export/word`;
}

export function getCashflowTimelineGraphUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/plans/${planId}/timeline`;
}

export function payPerPlanUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/payments/charge/plans/${planId}`;
}

export function getTaxSavingsForYearUrl(orgId, userId, year) {
  let url = `/TaxPlanningServices/org/${orgId}/users/${userId}/tax-savings`;
  if (year) {
    url += `?year=${year}`;
  }
  return url;
}

export function getAgreementsFileUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/terms-document-v2`;
}

export function getDashboardGridOrderUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/dashboard/order`;
}

export function getClientsForCoreFocusUploadUrl(orgId, userId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients`;
}

export function clientStatusUrl(orgId, userId, clientId, status) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/${clientId}/status/${status}`;
}

export function getDeleteDraftClientUrl(orgId, userId, clientId, documentId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/${clientId}/taxreturns/${documentId}`;
}

export function clientInactiveUrl(orgId, userId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/inactive`;
}

export function getTaxlabFilesUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/taxlab`;
}

export function getTaxlabFileHelpUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/taxlab`;
}

export function applyCouponUrl(orgId, userId, planId, coupon) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/coupons/validate?code=${coupon}&planId=${planId}`;
}

export function uploadDisclaimerUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/upload-disclaimer/markread`;
}

export function getPlanFilesUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/files`;
}

export function getOCRProgressUrl(orgId, userId, taskId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/document/task/${taskId}/ocrstatus`;
}

export function getOCRScanUrl(orgId, userId, fileId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/document/${fileId}/ocr`;
}

export function copyStrategiesToOtherUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/import/strategies`;
}

export function planStrategyDuplicateUrl(orgId, userId, planId, strategyId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/strategy/${strategyId}/duplicate`;
}

export function getReportCustomInfoUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/themes`;
}

export function getAddColorToInstanceUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/customreport-themes`;
}

export function getStrategiesListUrl(orgId, userId, tagId?) {
  let url = `/TaxPlanningServices/orgs/${orgId}/users/${userId}/strategy/suggessions`;
  if (tagId) {
    url += `?tagId=${encodeURIComponent(String(tagId))}`;
  }
  return url;
}

export function getOCRSuggestionsUrl(orgId, userId, clientId, taxReturnId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/${clientId}/taxreturn/${taxReturnId}/suggestions`;
}

export function getQuestionnarieOCRSuggestionsUrl(orgId, userId, docId, resetChatId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/questionnaire/document/${docId}/suggestion/${resetChatId}`;
}

/** RAP sandbox: AI suggestions without DB writes. Payload must include ocr_request_id. */
export function getRapQuestionnarieOCRSuggestionsUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/questionnaire/rap/suggestion`;
}

export function getPlanStrategiesForReviewUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${planId}/draft`;
}

export function getCreateTasksUrl(orgId, userId, clientId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/tasks?clientId=${clientId}`;
}

export function getFirmCreationUrl() {
  return `/TaxPlanningServices/webhook/chargebee`;
}

export function saveDraftForPlanUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/draftplan`;
}

export function getSavedDraftPlanUrl(orgId, userId, planId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/draftplan/${planId}`;
}

export function getClientTodoPlans(userID, orgid,clientId) {
  return `/TaxPlanningServices/users/${userID}/orgs/${orgid}/toDos/planList?clientId=${clientId}`;
}

export function getChatHistoryUrl(org,userId,chatId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/knolli/chatHistory/${chatId}`;
}

export function getQuestionnaireUtilizationUrl(orgId, userId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/questionnaire/utilization`;
}

export function getDRaftPlanChatIdUrl(org,userId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/questionnaire/saveChatId`;
}
export function getPlanExportLogUrl(orgId, userId, taxPlanId) {
  return `/TaxPlanningServices/org/${orgId}/users/${userId}/clients/${taxPlanId}/exports/log`;
}

export function getReorderPlanStrategiesUrl(orgId, userId, taxPlanId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/${taxPlanId}/reorder`;
}

export function getQuestionnarieStepUrl(orgId, userId, docId) {
  return `/TaxPlanningServices/orgs/${orgId}/users/${userId}/questionnaire/document/${docId}/questionnaire_track`;
}
@Injectable({
  providedIn: 'root'
})
export class TaxPlanningService extends TaxplanIQServices{

  terms: any;
  subscriptionData: any;
  clientData: any;
  defaultYearsData: any;
  paidPlans: any;
  readOnly = false;
  userFirstLogin = false;

  constructor(http: HttpClient) {
    super(http);
  }

  getTaxPlanningUsers(org, user, data, protectedView){
    const url = getTPCustomerListUrl(org, user, protectedView);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createTaxPlanForClient(org, userId, data){
    const url = createTaxPlanForClient(org, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTaxPlanForClient(org, userId, taxPlanId, year?, sortKey?, sortOrder?, protectedView?){
    const url = getTaxPlanForClient(org, userId, taxPlanId, year, sortKey, sortOrder, protectedView);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateTaxPlanForClient(org, userId, taxPlanId, obj){
    const url = getTaxPlanForClient(org, userId, taxPlanId);
    return this.update(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  addUpdateTaxStrategyLine(org, userId, taxPlanId, obj){
    const url = addUpdateStrategyLine(org, userId, taxPlanId);
    return this.update(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteTaxStrategyLine(org, userId, taxPlanId, strategyId){
    const url = deleteStrategyLine(org, userId, taxPlanId, strategyId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientsByUser(org, userId){
    const url = getClients(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getCostLines(org, userId, taxPlanId){
    const url = costLinesUrl(org, userId, taxPlanId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateCostLines(org, userId, taxPlanId, costLines){
    const url = costLinesUrl(org, userId, taxPlanId);
    return this.create(url, costLines, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateCashflowLines(org, userId, taxPlanId, cashflowLines){
    const url = cashflowLinesUrl(org, userId, taxPlanId);
    return this.create(url, cashflowLines, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getCashflowLines(org, userId, taxPlanId){
    const url = cashflowLinesUrl(org, userId, taxPlanId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  saveChecklist(org, userId, taxStrategyId, checklist){
    const url = saveChecklistUrl(org, userId, taxStrategyId);
    return this.create(url, checklist, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  strategyLineChecklist(org, userId, clientStrategyId, strategyLineId){
    const url = strategyLineChecklist(org, userId, clientStrategyId, strategyLineId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTaxPlanningSummary(orgId, userId, clientStrategyId, view?, filter?, noOfYears?, isMerged?){
    const url = taxPlanningSummary(orgId, userId, clientStrategyId, view, filter, noOfYears, isMerged);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientPlans(orgId, userId, clientId, currentYear, status?, isCustomer?){
    const url = clientPlanList(orgId, userId, clientId, currentYear, status, isCustomer);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientEntities(orgId, userId, clientId){
    const url = clientEntities(orgId, userId, clientId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createEntity(orgId, userId, clientId, entity){
    const url = clientEntities(orgId, userId, clientId);
    return this.create(url, entity, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  duplicatePlan(orgId, userId, taxPlanId, obj, planYear){
    const url = duplicatePlan(orgId, userId, taxPlanId, planYear);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  renamePlan(orgId, userId, taxPlanId, obj){
    const url = renamePlan(orgId, userId, taxPlanId);
    return this.patch(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateEntity(orgId, userId, clientId, entity){
    const url = clientEntity(orgId, userId, clientId, entity.id);
    return this.update(url, entity, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteEntity(orgId, userId, clientId, entityId){
    const url = clientEntity(orgId, userId, clientId, entityId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteClientTaxPlan(org, userId, taxPlanId, deleteAll?){
    const url = getTaxPlanDeleteForClient(org, userId, taxPlanId, deleteAll);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClients(org, user, data, protectedView?, clientStatus?, listType?){
    const url = getTaxPlanningClients(org, user, protectedView, clientStatus, listType);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createClient(org, user, data){
    const url = createTaxPlanningClientUrl(org, user);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateClient(org, user, clientId, data){
    const url = taxPlanningClientUrl(org, user, clientId);
    return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClient(org, user, clientId, protectedView?){
    if (this.clientData && this.clientData.id == clientId){
      return of(this.clientData);
    }
    const url = taxPlanningClientUrl(org, user, clientId, protectedView);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(map(res => {
      this.clientData = res;
      return this.clientData;
    }), catchError(e => this.handleError(e)));
  }

  clearClientData() {
    this.clientData = '';
  }

  deleteClient(org, user, clientId){
    const url = taxPlanningClientUrl(org, user, clientId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  addEditCustomRate(org, user, planId, customRate){
    const url = createCustomRateUrl(org, user, planId);
    return this.create(url, customRate, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateCustomRate(org, user, planId, customRate){
    const url = createCustomRateUrl(org, user, planId);
    return this.update(url, customRate, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteCustomRate(org, user, customRateId){
    const url = deleteCustomRateUrl(org, user, customRateId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getOrgExternalUsers(org, userId, requestObj) {
    const url = getExternalUsersUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getDisclaimer(user, orgId){
    const url = disclaimerUrl(orgId, user);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getHomePageContent(userId, orgId){
    const url = taxPlanningHomepageContentUrl(userId, orgId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  saveDisclaimer(user, orgId, disclaimer){
    const url = disclaimerUrl(orgId, user);
    return this.create(url, disclaimer, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  saveFeedback(orgId, userId, feedback){
    const url = feedbackUrl(orgId, userId);
    return this.create(url, feedback, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTermsAndConditions(orgId, userId){
    if (this.terms){
      return of(this.terms);
    }
    const url = getTermsAndConditionsUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(map(res => {
      this.terms = res;
      return this.terms;
    }), catchError(e => this.handleError(e)));
  }

  acceptTerms(orgId, userId, terms){
    const url = acceptTermsUrl(orgId, userId);
    return this.create(url, terms, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createTaxPlanningFirm(userId, orgId, client){
    const url = getTaxPlanningFirmCreationUrl(orgId, userId);
    return this.create(url, client, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  sendTaxPlanningInvitation(userId, orgId){
    const url = getInvitationUrl(orgId, userId);
    return this.create(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  publishStrategy(orgId, userId, planId, type, data){
    const url = planPublishUrl(orgId, userId, planId, type);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientTaxPlanningStatus(orgId, userId){
    const url = clientTaxPlanningStatusUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  saveCard(orgId, userId, billingData, code, yearlySubscribe, manageBilling): Observable<any> {
    const url = saveBillingInfoUrl(orgId, userId, code, yearlySubscribe, manageBilling);
    return this.create(url, billingData, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getPublicKey(orgId, userId){
    const url = getPublicKeyUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTaxPlanningInfoOfTask(orgId, userId, taskId){
    const url = getTaxPlanningInfoOfTaskUrl(orgId, userId, taskId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  generateTotalPublishedSavingsByStrategy(orgId, userId, graphType, year): Observable<any> {
    const url = getGenerateTotalPublishedSavingsByStrategyUrl(orgId, userId, graphType, year);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  generateTotalPublishedSavingsByClient(orgId, userId): Observable<any> {
    const url = getGenerateTotalPublishedSavingsByClientUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  generateTotalPublishedTaxplansByMonthMetricReport(orgId, userId, year): Observable<any> {
    const url = getTotalPublishedTaxplansByMonthUrl(orgId, userId, year);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  generateFirmsMostPopularPlansMetricReport(orgId, userId, year): Observable<any> {
    const url = getFirmsMostPopularPlansUrl(orgId, userId, year);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  generateTop5StrategiesMetricReport(orgId, userId, year): Observable<any> {
    const url = getTop5StrategiesUrl(orgId, userId, year);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  saveFirmAddressInfo(orgId, userId, data){
    const url = saveFirmAddressUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  validatePromoCodeForBilling(orgId, userId, code){
    const url = promoCodeForBillingUrl(orgId, userId, code);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  archiveOrUnarchivePlan(org, userId, taxPlanId, status, archiveOnly, planName){
    const url = getarchiveOrUnarchivePlanUrl(org, userId, taxPlanId, status, archiveOnly, planName);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientDefaultYear(orgId, userId, clientId){
    const url = getClientDefaultYearUrl(orgId, userId, clientId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientDefaultPlansInfo(orgId, userId, clientId): any{
    const url = getClientDefaultPlanInfoUrl(orgId, userId, clientId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  exportROIExcel(orgId, userId, data){
    const url = getExportROIExcelUrl(orgId, userId);

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json;charset=UTF-8');
    headers = headers.append('Authorization', 'Bearer ' + Session.getToken());
    const options: any = {
      responseType: 'arraybuffer',
      headers
    };

    return this.create(url, data, SOURCE_TYPE.JAVA, options).pipe(catchError(this.handleError));
  }

  updateROIMinimizedSections(org, user, planId, sections){
    const url = getROIMinimizedSectionsUrl(org, user, planId, sections);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getStrategyROIGraphData(orgId, userId, planId, year): any {
    const url = getStrategyROIGraphUrl(orgId, userId, planId, year);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateLogoDetails(org, userId, logoUrl){
    const url = getUpdateLogoUrl(org, userId, logoUrl);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getCustomerDashboardPieChartData(orgId, userId, graphType, year): Observable<any> {
    const url = getCustomerDashboardPieChartDataUrl(orgId, userId, graphType, year);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientTasksInfo(orgId, userId, year){
    const url = getClientTasksInfoUrl(orgId, userId, year);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getSubscriptionData(orgId, userId){
    const url = getSubscriptionDataUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateSubscriptionData(orgId, userId, data){
    const url = getSubscriptionDataUrl(orgId, userId);
    return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getSubscriptionStatus(orgId, userId){
    if (this.subscriptionData){
      return of(this.subscriptionData);
    }
    const url = subscriptionStatusUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(map(res => {
      this.subscriptionData = res;
      return this.subscriptionData;
    }), catchError(e => this.handleError(e)));

  }

  getSubscriptionDetails(orgId, userId): Observable<any> {
    const url = getSubscriptionDetailsUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  submitDoNotRenew(orgId, userId, data): Observable<any> {
    const url = doNotRenewUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  applyPromoCode(orgId, userId, data){
    const url = applyPromoCodeUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getCustomerLoginToken(org, userId, userEmail): Observable<any> {
    const url = getCustomerLoginToken(org, userId, userEmail);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientPlansList(org, userId, clientId, sortColumn?, sortOrder?, searchText?): Observable<any> {
    const url = getClientPlansListUrl(org, userId, clientId, sortColumn, sortOrder, searchText);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getUserSingleSignOnInfo(orgId, userId, data){
    const url = getUserSingleSignOnUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  makeDefaultYear(orgId, userId, year, graph){
    const url = getMakeDefaultYearUrl(orgId, userId, year, graph);
    return this.create(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getDashboardDefaultYearData(org, userId): Observable<any> {
    if (this.defaultYearsData){
      return of(this.defaultYearsData);
    }
    const url = getDashboardDefaultYearDataUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(map(res => {
      this.defaultYearsData = res;
      return this.defaultYearsData;
    }), catchError(e => this.handleError(e)));
  }

  getUserHistoryReportData(org, userId, sortColumn?, sortOrder?): Observable<any> {
    const url = getUserHistoryReportDataUrl(org, userId, sortColumn, sortOrder);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getFeedbackReportData(org, userId, sortColumn?, sortOrder?, firmId?, type?): Observable<any> {
    const url = getFeedbackReportDataUrl(org, userId, sortColumn, sortOrder, firmId, type);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  clearDefaultYearsData() {
    this.defaultYearsData = '';
  }

  setTerms(terms){
    this.terms = terms;
  }

  setHasLogo(hasLogo){
    this.terms.hasLogo = hasLogo;
  }

  updateNavigatedAction(orgId, userId, actionName){
    const url = getUpdateNavigateActionUrl(orgId, userId, actionName);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateTaxPlanHomeState(org, userId, clientId, taxPlanId, data){
    const url = getTaxPlanHomeStateUpdateUrl(org, userId, clientId, taxPlanId);
    return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  exportReportIntoImage(url, data): Observable<any>  {
    return this.create(url, data, null, null).pipe(catchError(this.handleError));
  }

  downloadRoiPresentation(orgId, userId, data){
    const url = getDownloadRoiPresentationUrl(orgId, userId);

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json;charset=UTF-8');
    headers = headers.append('Authorization', 'Bearer ' + Session.getToken());
    const options: any = {
      responseType: 'arraybuffer',
      headers
    };

    return this.create(url, data, SOURCE_TYPE.JAVA, options).pipe(catchError(this.handleError));
  }

  downloadWordQuestionnaire(orgId, userId, questionnaireId, data){
    const url = getDownloadWordQuestionnaireUrl(orgId, userId, questionnaireId);

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json;charset=UTF-8');
    headers = headers.append('Authorization', 'Bearer ' + Session.getToken());
    const options: any = {
      responseType: 'arraybuffer',
      headers
    };
    return this.create(url, data, SOURCE_TYPE.JAVA, options).pipe(catchError(this.handleError));
  }

  getPPTDownloadLink(orgId, userId, data){
    const url = getDownloadRoiPresentationUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  saveCustomPresentationData(orgId, userId, data){
    const url = getSaveCustomPresentationDataUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getCustomPresentationData(org, userId, planId): Observable<any> {
    const url = getCustomPresentationDataUrl(org, userId, planId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getPlanTaxEstimates(org, userId, planId): Observable<any> {
    const url = getPlanTaxEstimatesUrl(org, userId, planId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  savePlanTaxEstimates(org, userId, planId, data){
    const url = getPlanTaxEstimatesUrl(org, userId, planId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTpiqClientInfo(org, userId): Observable<any> {
    const url = getTpiqClientInfoUrl(org, userId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  savePlanIntroductionLetter(orgId, userId, planId, data){
    const url = getsavePlanIntroductionLetterUrl(orgId, userId, planId);
    return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getPlanStrategiesData(orgId, userId, data){
    const url = getPlanStrategiesDataUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getPublishedPlansForTaxEstimates(org, userId, customerId): Observable<any> {
    const url = getPublishedPlansForTaxEstimatesUrl(org, userId, customerId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  publishPlanTaxEstimates(orgId, userId, estimateId, publishType) {
    const url = getPublishPlanTaxEstimatesUrl(orgId, userId, estimateId, publishType);
    return this.patch(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getDashboardClickablePlans(org, userId, strategyId, year, sortKey?, sortOrder?): Observable<any> {
    const url = getDashboardClickablePlansUrl(org, userId, strategyId, year, sortKey, sortOrder);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getDashboardClickablePlansByMonth(org, userId, month, year, sortKey?, sortOrder?): Observable<any> {
    const url = getDashboardClickablePlansByMonthUrl(org, userId, month, year, sortKey, sortOrder);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getPlansForClient(org, userId, clientId): Observable<any> {
    const url = getPlansForClientUrl(org, userId, clientId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTaxPlanStrategiesInfo(org, userId, planId, type): Observable<any> {
    const url = getTaxPlanStrategiesInfoUrl(org, userId, planId, type);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createTaskForPlanStrategy(orgId, userId, id, goalDate){
    const url = getCreateTaskForPlanStrategyUrl(orgId, userId, id, goalDate);
    return this.create(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getActualProjectedGraphData(orgId, userId, planId): any {
    const url = getActualProjectedGraphUrl(orgId, userId, planId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  exportIntoWordDocument(org, userId, data){
    const url = geExportDocUrl(org, userId);

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json;charset=UTF-8');
    headers = headers.append('Authorization', 'Bearer ' + Session.getToken());
    const options: any = {
      responseType: 'arraybuffer',
      headers
    };

    return this.create(url, data, SOURCE_TYPE.JAVA, options).pipe(catchError(this.handleError));

  }

  getCashflowTimelineGraphData(orgId, userId, planId): any {
    const url = getCashflowTimelineGraphUrl(orgId, userId, planId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  payPerPlanInfo(orgId, userId, planId){
    const url = payPerPlanUrl(orgId, userId, planId);
    return this.create(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTaxSavingsForYear(orgId, userId, year): Observable<any> {
    const url = getTaxSavingsForYearUrl(orgId, userId, year);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAgreementsFile(orgId, userId): Observable<any> {
    const url = getAgreementsFileUrl(orgId, userId);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json;charset=UTF-8');
    headers = headers.append('Authorization', 'Bearer ' + Session.getToken());
    const options: any = {
      responseType: 'blob' as 'blob',
      headers
    };
    return this.query(url, SOURCE_TYPE.JAVA, options).pipe(catchError(this.handleError));
  }

  dashboardGridOrder(orgId, userId): Observable<any> {
    const url = getDashboardGridOrderUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getClientsForCoreFocusUpload(org, user){
    const url = getClientsForCoreFocusUploadUrl(org, user);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  setUserFirstLogin(value) {
    this.userFirstLogin = value;
  }

  getUserFirstLogin() {
    return this.userFirstLogin;
  }

  setPaidPlans(plans){
    this.paidPlans = plans;
  }

  getPaidPlans(){
    return this.paidPlans || [];
  }

  setUserReadOnly(value){
    this.readOnly = value;
  }

  getUserReadOnly(){
    return this.readOnly || false;
  }

  updateClientStatus(org, user, clientId, status){
    const url = clientStatusUrl(org, user, clientId, status);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteDraftClient(org, user, clientId, docId){
    const url = getDeleteDraftClientUrl(org, user, clientId, docId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  makeClientInactive(orgId, userId, data){
    const url = clientInactiveUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getTaxlabFiles(orgId, userId){
    const url = getTaxlabFilesUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  postTaxlabFileHelp(orgId, userId, data){
    const url = getTaxlabFileHelpUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removeTaxlab(userId, orgId, taxlabId): Observable<any> {
    let url = getTaxlabFilesUrl(orgId, userId);
    url += `/${taxlabId}`;
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateTaxlab(orgId, userId, taxlab) {
    let url = getTaxlabFilesUrl(orgId, userId);
    url += `/${taxlab.id}?status=${taxlab.status}`;
    return this.update(url, taxlab, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  applyCouponForPlan(orgId, userId, planId, coupon){
    const url = applyCouponUrl(orgId, userId, planId, coupon);
    return this.update(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  userUploadDisclaimer(orgId, userId){
    const url = uploadDisclaimerUrl(orgId, userId);
    return this.patch(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getPlanFiles(orgId, userId, taxPlanId){
    const url = getPlanFilesUrl(orgId, userId, taxPlanId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getOCRProgress(orgId, userId, taskId) {
    const url = getOCRProgressUrl(orgId, userId, taskId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  scanFile(orgId, userId, fileId, payload) {
    const url = getOCRScanUrl(orgId, userId, fileId);
    return this.update(url, payload, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  copyStrategiesToOther(orgId, userId, data) {
    const url = copyStrategiesToOtherUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  duplicatePlanStrategy(orgId, userId, planId, strategyLineId){
    const url = planStrategyDuplicateUrl(orgId, userId, planId, strategyLineId);
    return this.create(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  addColorToReportCustomColors(orgId, userId, data){
    const url = getReportCustomInfoUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getReportCustomInfo(orgId, userId){
    const url = getAddColorToInstanceUrl(orgId, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  addColorToInstance(orgId, userId, data){
    const url = getAddColorToInstanceUrl(orgId, userId);
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getStrategiesList(org, userId, tagId?){
    const url = getStrategiesListUrl(org, userId, tagId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getOCRSuggestions(org, userId, clientId, taxReturnId) {
    const url = getOCRSuggestionsUrl(org, userId, clientId, taxReturnId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getQuestionnarieOCRSuggestions(org: string | number, userId: string | number, docId: string | number, resetChatId: boolean, obj: any) {
    const url = getQuestionnarieOCRSuggestionsUrl(org, userId, docId, resetChatId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  /** RAP sandbox: AI suggestions without DB writes. obj must include ocr_request_id. */
  getRapQuestionnarieOCRSuggestions(org, userId, obj) {
    const url = getRapQuestionnarieOCRSuggestionsUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  draftSelectedStrategies(org, userId, taxPlanId){
    const url = getPlanStrategiesForReviewUrl(org, userId, taxPlanId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  savePlanStrategiesForReview(org, userId, taxPlanId, obj){
    const url = getPlanStrategiesForReviewUrl(org, userId, taxPlanId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createTasks(org, userId, clientId, obj) {
    const url = getCreateTasksUrl(org, userId, clientId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createFirm(data){
    const url = getFirmCreationUrl();
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  saveDraftForPlan(org, userId, obj){
    const url = saveDraftForPlanUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getDraftForPlan(org, userId, planId){
    const url = getSavedDraftPlanUrl(org, userId, planId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateDraftForPlan(org, userId, planId, obj){
    const url = getSavedDraftPlanUrl(org, userId, planId);
    return this.update(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAllClientPlans(userId,orgId,clientId){
    const url = getClientTodoPlans(userId,orgId,clientId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError)); 
  }

  getChatHistory(org,userId,chatId: number) {
      const url = getChatHistoryUrl(org,userId,chatId);
      return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  trackQuestionnaireUtilization(org, userId, obj){
    const url = getQuestionnaireUtilizationUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }
  
  saveDRaftPlanChatId(org, userId, obj){
    const url = getDRaftPlanChatIdUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  reorderPlanStrategies(org, userId, planId, obj){
    const url = getReorderPlanStrategiesUrl(org, userId, planId);
    return this.update(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateQuestionnarieStep(org, userId, docId, obj){
    const url = getQuestionnarieStepUrl(org, userId, docId);
    return this.update(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  clearSubscriptionData() {
    this.subscriptionData = null;
  }

  logReportDownload(org: string, userId: string, payload: any) {
    const taxPlanId = payload?.taxPlan?.id;
    if (!taxPlanId) return of(null); // should never happen, just to be safe
  
    const url = getPlanExportLogUrl(org, userId, taxPlanId);
    const formattedDate = new Date().toISOString().slice(0, 19).replace('T', ' ');
    const body = {
      taxPlanId,
      documentType: payload.format,
      exportDate: formattedDate
    };
  
    return this.create(url, body, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  // ============================================================================
  // RAP Edit Session Methods (Sandboxed Open-in-RAP)
  // ============================================================================

  /**
   * Single Gateway API call to commit the entire Sandbox session
   * 
   * Handles three modes:
   * - OVERWRITE: Replace existing plan (archive → delete → insert)
   * - CREATE_NEW: Create as brand new plan
   * - SAVE_DRAFT_SESSION: Mid-session persistence (no commit)
   * 
   * @param data Complete RAP commit payload (meta + plan data)
   * @returns Observable of the committed plan or draft save confirmation
   */
  commitRapEditSession(data: RapCommitPayload): Observable<any> {
    const url = `/TaxPlanningServices/orgs/${data.meta.orgId}/users/${data.meta.userId}/clientstrategy/commit-rap-session`;
    return this.create(url, data, SOURCE_TYPE.JAVA).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Retrieves a saved RAP edit session draft
   * Used when user returns to continue editing a previously saved session
   * 
   * @param orgId Organization ID
   * @param userId User ID
   * @param planId Source plan ID
   * @returns Observable of RapPlanData if draft exists, null otherwise
   */
  getRapEditSessionDraft(orgId: string, userId: string, planId: string): Observable<RapPlanData | null> {
    const url = `/TaxPlanningServices/orgs/${orgId}/users/${userId}/clientstrategy/get-rap-draft/${planId}`;
    return this.query(url, SOURCE_TYPE.JAVA).pipe(
      map((response) => {
        // Backend returns 204 No Content when no draft exists (response will be null/empty)
        // This is expected business logic, not an error
        return response || null;
      }),
      catchError((error) => {
        // 404 means no draft found - this is expected, not an error (legacy handling)
        if (error.status === 404 || error.status === 204) {
          return of(null);
        }
        return this.handleError(error);
      })
    );
  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }
}
